import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { FilterModel } from 'ag-grid-community';
import { OperatorFirestoreService } from '../../services/operator.firestore.service';
import { OperatorActions } from './operator.action';
import { OperatorStateModel } from './operator.store';

@State<OperatorStateModel>({
  name: 'operators',
  defaults: {
    operators: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class OperatorState {
  private operatorsService = inject(OperatorFirestoreService);
  // private operatorState = inject(OperatorState);
  // private dbOperator = inject(OrmService).operatorCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(OperatorActions.GetAllOperators)
  async getAllOperators(ctx: StateContext<OperatorStateModel>) {
    ctx.patchState({ isLoading: true });
    const operators = await this.operatorsService.GetAll();
    ctx.patchState({
      operators: operators.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(OperatorActions.UpdateOperator)
  async updateOperator(ctx: StateContext<OperatorStateModel>, { operatorData, ref }: OperatorActions.UpdateOperator) {
    await this.operatorsService.Update(ref, operatorData);
  }

  @Action(OperatorActions.UpdateOperatorResult)
  updateOperatorResult(ctx: StateContext<OperatorStateModel>, { data }: OperatorActions.UpdateOperatorResult) {
    patchState<OperatorStateModel>(ctx, 'operators', data);
  }

  @Action(OperatorActions.PaginateQueryOperator)
  async queryOperator(
    ctx: StateContext<OperatorStateModel>,
    { request, isResetAfterFilterOrSort }: OperatorActions.PaginateQueryOperator,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['operatorId']) {
    //   (request.filterModel as FilterModel)['operatorId']['values'] = (request.filterModel as FilterModel)[
    //     'operatorId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(OperatorState.operators).find((operator) => operator.companyName === v)?.ref
    //   );
    // }
    // if (operatorId) {
    //   request.filterModel = {
    //     operatorId: { filter: this.dbOperator.ref(this.dbOperator.id(operatorId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.operatorsService.SetQuery({
      ...request,
      count: state.operators.length,
      data: state.operators,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.operators.length;
      state.operators = [];
      state.operators.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.operators = [];
      state.operators.length = await this.operatorsService.GetBuildedCount(runs);
    }
    if (state.operators.length !== 0) {
      runs.push(...this.operatorsService.SetLimit({ ...request, count: state.operators.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const operators = await this.operatorsService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        operators.reverse().forEach(
          ({ data, ref }, i) =>
            (state.operators[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        operators.forEach(
          ({ data, ref }, i) =>
            (state.operators[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, operators: state.operators });
  }

  @Action(OperatorActions.OperatorError)
  operatorsError(ctx: StateContext<OperatorStateModel>, { error }: OperatorActions.OperatorError) {
    console.error({ error });
    // await this.operatorsService.Update(id, operatorsData);
  }

  @Action(OperatorActions.DeleteOperators)
  async deletetoperators(ctx: StateContext<OperatorStateModel>, { refs }: OperatorActions.DeleteOperators) {
    await this.operatorsService.BatchDelete(refs);
  }

  @Action(OperatorActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<OperatorStateModel>,
    { fields, timePeriod, filterModel }: OperatorActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (operatorId) {
    //   filterModel = { operatorId: { filter: this.dbOperator.ref(this.dbOperator.id(operatorId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.operatorsService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.operatorsService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.operatorsService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static operators(state: OperatorStateModel) {
    return state.operators;
  }
  @Selector()
  static operatorsCount(state: OperatorStateModel) {
    return state.operators.length;
  }

  @Selector()
  static sums(state: OperatorStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: OperatorStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static operatorsState(state: OperatorStateModel) {
    return state;
  }
}
